import HTTP from "../../utils/Http";
import * as userActions from "./actions";
import { notify } from "reapop";

export function getUser(id) {
  return dispatch => {
    dispatch(userActions.getUserStart());
    HTTP.get("/users/" + id)
      .then(res => {
        dispatch(userActions.getUserSuccess(res.data.data));
      })
      .catch(err => {
        dispatch(userActions.getUserFail(err.response.data.message));
        dispatch(notify({ message: "Could not get user", status: "error" }));
      });
  };
}

export function editUser(id, values) {
  return dispatch => {
    dispatch(userActions.editUserStart());
    HTTP.put("/users/" + id, values)
      .then(res => {
        dispatch(userActions.editUserSuccess(res.data));
        dispatch(notify({ message: "User has been saved", status: "success" }));
      })
      .catch(err => {
        dispatch(userActions.editUserFail(err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message));
        dispatch(
          notify({ message: err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message, status: "error" })
        );
      });
  };
}

export function removeUser(entries) {
  return dispatch => {
    dispatch(userActions.removeUserStart());
    HTTP({ method: "delete", url: "/users/", data: { id: entries } })
      .then(res => {
        dispatch(userActions.removeUserSuccess(res.data));
        dispatch(
          notify({ message: "User(s) has been deleted", status: "success" })
        );
        dispatch(getUsers());
      })
      .catch(err => {
        dispatch(userActions.removeUserFail(err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message));
        dispatch(
          notify({ message: err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message, status: "error" })
        );
      });
  };
}

export function getUsers(limit, offset, search) {
  return dispatch => {
    dispatch(userActions.getUsersStart());
    HTTP.get("/users", {
      params: { limit: limit, offset: offset, search: search }
    })
      .then(res => {
        const data = res.data;
        dispatch(userActions.getUsersSuccess(data.data));
      })
      .catch(err => {
        dispatch(userActions.getUsersFail(err.response.data.message));
        dispatch(
          notify({ message: err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message, status: "error" })
        );
      });
  };
}

export function createUser(data) {
  return dispatch => {
    dispatch(userActions.createUserStart());
    HTTP.post("/users", data)
      .then(res => {
        dispatch(userActions.createUserSuccess(res.data));
        dispatch(notify({ message: "User has been saved", status: "success" }));
      })
      .catch(err => {
        dispatch(userActions.createUserFail(err.response.data.message));
        dispatch(notify({ message: "Error creating user", status: "error" }));
      });
  };
}

export function getUserGroups() {
  return dispatch => {
    dispatch(userActions.getUserGroupsStart());
    HTTP.get("/roles")
      .then(res => {
        dispatch(userActions.getUserGroupsSuccess(res.data.data));
      })
      .catch(err => {
        dispatch(userActions.getUserGroupsFail(err.response.data.message));
      });
  };
}

export function getUserGroup(id) {
  return dispatch => {
    dispatch(userActions.getUserGroupStart());
    HTTP.get("/api/usergroups/" + id)
      .then(res => {
        dispatch(userActions.getUserGroupSuccess(res.data));
      })
      .catch(err => {
        dispatch(userActions.getUserGroupFail(err.response.data.message));
      });
  };
}

export function editUserGroup(id, values) {
  return dispatch => {
    dispatch(userActions.editUserGroupStart());
    HTTP.put("/api/usergroups/" + id, values)
      .then(res => {
        dispatch(userActions.editUserGroupSuccess(res.data));
        dispatch(notify({ message: "User has been saved", status: "success" }));
      })
      .catch(err => {
        dispatch(userActions.editUserGroupFail(err.response.data.message));
        dispatch(
          notify({ message: err.response.data.message, status: "error" })
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/system/store/Users/services.js